import HighlightLogoIcon from '@renderer/components/Icons/HighlightLogoIcon'
import { useGatewayChannel } from '@renderer/hooks/useGatewayChannel'
import { useToast } from '../use-toast'

type ToastApi = ReturnType<typeof useToast>

export function useGatewayToasts(toast: ToastApi) {
  useGatewayChannel('toast', (payload) => {
    toast.add({
      analytics: { type: 'gateway' },
      title: payload.title ?? 'Notification',
      description: payload.message,
      icon: <HighlightLogoIcon size={24} />,
      duration: 5000,
    })
  })
}
